/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Parked
 * 
 * 1 = PendingReview
 * 
 * 2 = Completed
 * 
 * 3 = ShortDelivery
 */
export enum GoodsInStatus {
  Parked = 0,
  PendingReview = 1,
  Completed = 2,
  ShortDelivery = 3
}
